// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: var(--color-base-gray-light);
  border-radius: var(--border-radius-lg);
  padding: 20px 0 10px;
  margin-top: auto;
  width: 100%;
  border-top: 1px solid #e0e0e0;
}

.footer-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1110px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo img {
  height: 50px;
  margin-bottom: 5px;
}

.footer-logo span {
  font-size: 12px;
  color: #666;
}

.footer-contacts a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
}
.info-block{
  display: flex;
  flex-direction: column;
}
.footer-phone {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-phone a {
  color: #333;
  text-decoration: none;
  font-size: var(--font-size-sm);
}

.footer-schedule {
  margin: 0;
  color: #333;
  font-size: var(--font-size-sm);
}

.footer-note {
  color: #f44336;
  font-size: 12px;
  max-width: 400px;
  text-align: left;
}
.footer-button{
  background-color: var(--color-base-gray-light);
  border: 2px solid var(--color-background);
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-logo, .footer-contacts, .footer-phone, .footer-button {
    margin-bottom: 15px;
  }
  
  .footer-note {
    max-width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".footer {\n  background-color: var(--color-base-gray-light);\n  border-radius: var(--border-radius-lg);\n  padding: 20px 0 10px;\n  margin-top: auto;\n  width: 100%;\n  border-top: 1px solid #e0e0e0;\n}\n\n.footer-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1110px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.footer-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.footer-logo img {\n  height: 50px;\n  margin-bottom: 5px;\n}\n\n.footer-logo span {\n  font-size: 12px;\n  color: #666;\n}\n\n.footer-contacts a {\n  color: #333;\n  text-decoration: none;\n  font-size: 16px;\n}\n.info-block{\n  display: flex;\n  flex-direction: column;\n}\n.footer-phone {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.footer-phone a {\n  color: #333;\n  text-decoration: none;\n  font-size: var(--font-size-sm);\n}\n\n.footer-schedule {\n  margin: 0;\n  color: #333;\n  font-size: var(--font-size-sm);\n}\n\n.footer-note {\n  color: #f44336;\n  font-size: 12px;\n  max-width: 400px;\n  text-align: left;\n}\n.footer-button{\n  background-color: var(--color-base-gray-light);\n  border: 2px solid var(--color-background);\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .footer-logo, .footer-contacts, .footer-phone, .footer-button {\n    margin-bottom: 15px;\n  }\n  \n  .footer-note {\n    max-width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
